import type { IRoute } from '@/shared/models/route.model';

import { lazy } from 'react';

const BoostView = lazy(() => import('./BoostView').then((m) => ({ default: m.BoostView })));
const BoostSuccess = lazy(() => import('./BoostSuccess').then((m) => ({ default: m.BoostSuccess })));
const BoostCancel = lazy(() => import('./BoostCancel').then((m) => ({ default: m.BoostCancel })));

export const boostRoutes: IRoute[] = [
  {
    path: '/boost/:companyId/:propertyId',
    component: BoostView,
  },
  {
    path: '/boost/success',
    component: BoostSuccess,
  },
  {
    path: '/boost/payment',
    component: BoostCancel,
  },
];
